import React, {useEffect, useState} from "react"
import {BuildingOfficeIcon, KeyIcon, UserCircleIcon} from "@heroicons/react/24/outline"

import {IUser} from "@backend/types"
import {Card, Loading, VerticalMenu} from "@components/index"
import {MenuType} from "@components/types"
import {userApiCalls} from "../service"

import {OrganizationSettings, PasswordUpdate, ProfileSettings} from "../components/Forms"


const subNavigation: MenuType[] = [
    {
        title: "Profile",
        icon: UserCircleIcon,
        component: (data, onUpdate) => <ProfileSettings user={data} onUpdate={onUpdate}/>
    },
    {
        title: "Organization",
        icon: BuildingOfficeIcon,
        component: (data, onUpdate) => <OrganizationSettings user={data} onUpdate={onUpdate}/>
    },
    {
        title: "Password",
        icon: KeyIcon,
        component: (data) => <PasswordUpdate user={data}/>
    }

]

export default function Profile() {
    const [activeTabIndex, setActiveTabIndex] = useState<number>(0)
    const [user, setUser] = useState<IUser | null>(null)


    useEffect(() => {
        userApiCalls
            .currentUser()
            .then(setUser)
    }, [])

    function onUpdate(val = {}) {
        const savedUser = {
            ...user,
            ...val
        }
        setUser(savedUser)
    }

    if (!user)
        return <Loading/>


    return <Card
        title="Profile and Settings"
        bodyClassName="p-0"
    >
        <div className="divide-y divide-gray-200 lg:grid lg:grid-cols-12 lg:divide-x lg:divide-y-0">
            <aside className="py-2 lg:col-span-3">
                <VerticalMenu
                    navMenu={subNavigation}
                    activeIndex={activeTabIndex}
                    setActiveIndex={setActiveTabIndex}
                />
            </aside>
            <div className="lg:col-span-9">
                {subNavigation[activeTabIndex].component(user, onUpdate)}
            </div>


        </div>
    </Card>
}